import { ReactNode, useState } from "react";

import { SubTab, SubTabs } from "components/layout";
import { RELEASE_STAGES, ReleaseStage } from "hooks/tivoApps";
import { classes } from "utils/classes";

import { getReleaseStageTabLabel } from "../utils";
import styles from "./ReleaseStageTabs.scss";

type ReleaseStageTabsProps = {
  className?: string;
  getTabTestId?: (stage: ReleaseStage) => string;
  children: (selectedStage: ReleaseStage) => ReactNode;
};

export function ReleaseStageTabs({
  className = "",
  getTabTestId,
  children,
}: ReleaseStageTabsProps) {
  const [selectedStage, setSelectedStage] = useState<ReleaseStage>("rs1");

  return (
    <>
      <SubTabs
        className={classes(styles.base, className)}
        hideScrollButtons
        tabsClassName={styles.tabsContainer}
      >
        {RELEASE_STAGES.map((stage) => (
          <SubTab
            key={stage}
            activeClassName={styles.activeStage}
            active={selectedStage === stage}
            text={getReleaseStageTabLabel(stage)}
            dataTestId={getTabTestId?.(stage)}
            onClick={() => setSelectedStage(stage)}
          />
        ))}
      </SubTabs>
      {children(selectedStage)}
    </>
  );
}
